import { safeGet } from "@/modules/utils/safe-get";
import { type TypographyProps } from "@/components/essentials/typography";
import { type CheckboxProps } from "./Checkbox";
import { type CheckboxBreakPointSize, type CheckboxSize } from "./type";

interface CheckboxSizeValue {
  readonly iconSize: CheckboxProps["fontSize"];
  readonly typographyVariant: Omit<TypographyProps["variant"], "TypographyBreakpointsVariant">;
}
const checkboxSize: Record<CheckboxSize, CheckboxSizeValue> = {
  sm: {
    iconSize: "0.5rem",
    typographyVariant: "text4",
  },
  md: {
    iconSize: "0.75rem",
    typographyVariant: "text2",
  },
  lg: {
    iconSize: "1rem",
    typographyVariant: "text1",
  },
};
const switchCheckboxSize = (size: CheckboxSize): CheckboxSizeValue => {
  return safeGet(checkboxSize, size);
};

export const injectCheckboxSize = (size: CheckboxSize | CheckboxBreakPointSize): CheckboxSizeValue => {
  if (typeof size === "string") {
    return switchCheckboxSize(size);
  } else {
    return {
      iconSize: {
        base: switchCheckboxSize(size.base).iconSize as string,
        sm: switchCheckboxSize(size.sm).iconSize as string,
        md: switchCheckboxSize(size.md).iconSize as string,
        lg: switchCheckboxSize(size.lg).iconSize as string,
        xl: switchCheckboxSize(size.xl).iconSize as string,
        "2xl": switchCheckboxSize(size["2xl"]).iconSize as string,
      },
      typographyVariant: {
        base: switchCheckboxSize(size.base).typographyVariant,
        sm: switchCheckboxSize(size.sm).typographyVariant,
        md: switchCheckboxSize(size.md).typographyVariant,
        lg: switchCheckboxSize(size.lg).typographyVariant,
        xl: switchCheckboxSize(size.xl).typographyVariant,
        "2xl": switchCheckboxSize(size["2xl"]).typographyVariant,
      },
    };
  }
};
